<template>
  <div
    data-test="calendar-date"
    class="boss-calendar-date"
    :class="classObject"
    @click="changeNg"
  >
    <span class="boss-calendar-date-text">{{ displayText }}</span>
    <div
      v-if="isCandidate"
      data-test="candidate"
      class="boss-calendar-date-candidate"
    />
  </div>
</template>

<script>
export default {
  props: {
    // 編集可能不可
    canEdit: {
      type: Boolean,
      required: true
    },
    layoutType: {
      type: String,
      required: true
    },
    // 候補日かどうか
    isCandidate: {
      type: Boolean,
      required: true
    },
    // 表示する曜日or日付
    displayText: {
      type: String,
      required: true
    }
  },
  computed: {
    classObject () {
      return {
        'boss-calendar-date-edit': this.canEdit,
        // 曜日 or 過去日付 or NGの場合に背景色変更
        'boss-calendar-date-week': this.layoutType === 'week',
        'boss-calendar-date-pass': this.layoutType === 'pass',
        'boss-calendar-date-ng': this.layoutType === 'ng'
      }
    }
  },
  methods: {
    // 選択された時の処理
    changeNg () {
      if (this.canEdit) {
        this.$emit('changeNgDate', this.layoutType, Number(this.displayText))
      }
      if (this.layoutType === 'week') {
        this.$emit('changeNgWeek')
      }
    }
  }
}
</script>
